<template>
  <div class="tcgaExpAll">
    <a-row>
      <a-col :span="24"> <div id="containerTCGAPaired"></div></a-col>
      <a-col :span="24">
        <a-input
          type="text"
          addon-before="Width : "
          addon-after="px"
          v-model="tWidth"
        />
        <br />
        <br />
        <a-input
          type="text"
          addon-before="Height: "
          addon-after="px"
          v-model="tHeight"
        />
      </a-col>
      <a-col :span="24" style="margin-top: 10px">
        <a-button type="primary" @click="changePlot()">Set options</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import exporting from "highcharts/modules/exporting";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
exporting(Highcharts);

export default {
  data() {
    return {
      tWidth: 1200,
      tHeight: 600,
      pWidth: 1200,
      pHeight: 600,
    };
  },
  watch: {
    pHeight() {
      //先查ensgid
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
          {
            params: { genename: this.$route.query.gene },
          }
        )
        .then((response) => {
          //this.ensgID = response.data[0]["ensgID"];
          //开始绘图
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_tcgaAll.php",
              {
                params: {
                  gene: response.data[0]["ensgId"],

                  datatype: "expAll",
                },
              }
            )
            .then((response) => {
              this.moreChart(response.data["data1"], response.data["data2"]);
              // console.log(response.data);
            });
        });
    },
    pWidth() {
      //先查ensgid
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
          {
            params: { genename: this.$route.query.gene },
          }
        )
        .then((response) => {
          //this.ensgID = response.data[0]["ensgID"];
          //开始绘图
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_tcgaAll.php",
              {
                params: {
                  gene: response.data[0]["ensgId"],

                  datatype: "expAll",
                },
              }
            )
            .then((response) => {
              this.moreChart(response.data["data1"], response.data["data2"]);
              // console.log(response.data);
            });
        });
    },
  },
  mounted() {
    //先查ensgid
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
        {
          params: { genename: this.$route.query.gene },
        }
      )
      .then((response) => {
        //this.ensgID = response.data[0]["ensgID"];
        //开始绘图
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_tcgaAll.php",
            {
              params: {
                gene: response.data[0]["ensgId"],

                datatype: "expAll",
              },
            }
          )
          .then((response) => {
            this.moreChart(response.data["data1"], response.data["data2"]);
            // console.log(response.data);
          });
      });
  },
  methods: {
    changePlot() {
      // Assume default values for pWidth and pHeight, if necessary

      this.pWidth = this.tWidth;

      this.pHeight = this.tHeight;
    },
    moreChart(data1, data2) {
      if (this.chart) {
        this.chart.destroy();
      }
      // 初始化 Highcharts 图表
      this.chart = new Highcharts.chart("containerTCGAPaired", {
        //去掉水印
        credits: {
          enabled: false,
        },
        //图标配置
        chart: {
          type: "boxplot",
        },
        title: {
          text: "The gene expression profile across all tumor samples and normal tissues",
        },
        legend: {
          align: "right", // 将图例右对齐
          verticalAlign: "top", // 将图例顶部对齐
          layout: "vertical", // 图例布局为垂直
          x: -20, // x轴方向的偏移量
          y: 0, // y轴方向的偏移量
        },
        // legend: {
        //   enabled: false,
        // },
        xAxis: {
          categories: [
            "ACC",
            "BLCA",
            "BRCA",
            "CESC",
            "CHOL",
            "COAD",
            "DLBC",
            "ESCA",
            "GBM",
            "HNSC",
            "KICH",
            "KIRC",
            "KIRP",
            "LAML",
            "LGG",
            "LIHC",
            "LUAD",
            "LUSC",
            "MESO",
            "OV",
            "PAAD",
            "PCPG",
            "PRAD",
            "READ",
            "SARC",
            "SKCM",
            "STAD",
            "TGCT",
            "THCA",
            "THYM",
            "UCEC",
            "UCS",
            "UVM",
          ],
          lineColor: "black",
          lineWidth: 2,
          tickWidth: 2,
          tickLength: 5,
          tickColor: "black",
          crosshair: true,
          title: {
            text: "",
          },
        },
        yAxis: {
          title: {
            text: "Log2(TPM+1)",
          },
          tickWidth: 2,
          tickColor: "black",
          lineWidth: 2,
          lineColor: "black",
          tickLength: 5,
          gridLineColor: "white",
          //   plotLines: [
          //     {
          //       value: 932,
          //       color: "red",
          //       width: 1,
          //       label: {
          //         text: "理论模型: 932",
          //         align: "center",
          //         style: {
          //           color: "gray",
          //         },
          //       },
          //     },
          //   ],
        },
        plotOptions: {
          boxplot: {
            // fillColor: "#F0F0E0",
            // lineWidth: 2,
            //中位线
            medianColor: "white",
            medianWidth: 1,
            medianDashStyle: "dashed",
            //连接线
            stemColor: "black",
            stemDashStyle: "dot",
            stemWidth: 1,
            //上下线
            whiskerColor: "black",
            whiskerLength: "40%",
            whiskerWidth: 2,
            // groupPadding: 0.2,
            // pointWidth: 0.1,
          },
        },
        // tooltip: {
        //   pointFormat:
        //     '<span style="color:{point.color}">\u25CF</span> <b> {series.name}</b><br/>' + // eslint-disable-line no-dupe-keys
        //     "最大值: {point.high}<br/>" +
        //     "Q2\t: {point.q3}<br/>" +
        //     "中位数: {point.median}<br/>" +
        //     "Q1\t: {point.q1}<br/>" +
        //     "最小值: {point.low}<br/>",
        // },
        // exporting: {
        //   chartOptions: {
        //     chart: {
        //       width: 1200, // 设置导出图表的宽度
        //       height: 600, // 设置导出图表的高度
        //     },
        //   },
        // },
        exporting: {
          filename:
            "Expression of " + this.$route.query.gene + " in pan-cancers",
          // chartOptions: {
          //   // specific options for the exported image
          //   chart: {
          sourceWidth: this.pWidth,
          sourceHeight: this.pHeight,
          scale: 1,
          //   },
          // },
        },
        series: [
          {
            name: "Normal",
            data: data2,
            color: "#4572a7",
            fillColor: "#4572a7",
          },
          {
            name: "Tumor",
            data: data1,
            color: "#aa4643",
            fillColor: "#aa4643",
          },

          // {
          //   name: "TPM",
          //   data: yaxis,
          //   color: "#90CCF9",
          //   fillColor: "#90CCF9",
          //   // tooltip: {
          //   //   headerFormat: "<em>实验号码： {point.key}</em><br/>",
          //   // },
          // },
          //   {
          //     name: "异常值",
          //     color: Highcharts.getOptions().colors[0],
          //     type: "scatter",
          //     data: [
          //       // x, y positions where 0 is the first category
          //       [0, 644],
          //       [4, 718],
          //       [4, 951],
          //       [4, 969],
          //     ],
          //     stickyTracking: false,
          //     marker: {
          //       fillColor: "white",
          //       lineWidth: 1,
          //       lineColor: Highcharts.getOptions().colors[0],
          //     },
          //     tooltip: {
          //       pointFormat: "Observation: {point.y}",
          //     },
          //   },
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit css to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
